const binding = { modules: {}, dataActions: {} };

    (binding.modules['custom-link'] = {
        c: () => require('partner/modules/custom-link/custom-link.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'custom-link',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/custom-link'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|custom-link|custom-link'] = {
                c: () => require('partner/modules/custom-link/custom-link.view.tsx'),
                cn: '__local__-__local__-custom-link'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };